var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M10.8711 0.0078125C5.35109 0.0078125 0.871094 4.48781 0.871094 10.0078C0.871094 15.5278 5.35109 20.0078 10.8711 20.0078C16.3911 20.0078 20.8711 15.5278 20.8711 10.0078C20.8711 4.48781 16.3911 0.0078125 10.8711 0.0078125ZM10.8711 18.0078C6.46109 18.0078 2.87109 14.4178 2.87109 10.0078C2.87109 5.59781 6.46109 2.00781 10.8711 2.00781C15.2811 2.00781 18.8711 5.59781 18.8711 10.0078C18.8711 14.4178 15.2811 18.0078 10.8711 18.0078ZM15.4611 5.58781L8.87109 12.1778L6.28109 9.59781L4.87109 11.0078L8.87109 15.0078L16.8711 7.00781L15.4611 5.58781Z",
          fill: "#0E9F6E",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }